import { Box } from '@hub/box'
import { IconButton } from '@hub/button'
import { SearchMediumIcon } from '@hub/icon'
import React from 'react'
import { SearchButtonProps } from './types'

export const SearchButtonSmall: React.FC<SearchButtonProps> = ({
  onClick,
  controlledElementId,
  sx,
}) => (
  <Box role="search" sx={sx}>
    <IconButton
      icon={<SearchMediumIcon boxSize="size-icon-md" />}
      aria-label="Open Search, you can search stores, brands, products, and more"
      variant="transparent"
      colorScheme="licorice"
      aria-controls={controlledElementId}
      sx={{
        minWidth: 0,
        height: 'auto',
      }}
      onClick={onClick}
    />
  </Box>
)
